export default __webpack_public_path__ + "static/media/Group 27104.70ba9748.svg";